import {
  Directive,
  Input,
  OnDestroy,
  OnChanges,
  OnInit,
  ElementRef,
  SimpleChanges,
  Output,
  EventEmitter
} from '@angular/core';
import tippy, { roundArrow, Instance } from 'tippy.js';

import browserHelper from '@utils/browser-helper';

type IFBTooltipPlacement =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end';

type IFBTooltipVariant = 'hint' | 'regular' | 'wide' | 'wide-hint';

const VariantThemeMap = {
  regular: 'fb',
  hint: 'fb-hint',
  wide: 'fb',
  'wide-hint': 'fb-hint'
};

export const TOOLTIP_DEFAULT_OPTIONS = {
  allowHTML: true,
  animation: 'scale-subtle',
  arrow: roundArrow,
  ignoreAttributes: true,
  maxWidth: 200,
  duration: 0,
  placement: 'top',
  theme: VariantThemeMap.regular,
  zIndex: 1070
};
//todo=> this library is deprecated
// Wrapper around tippy
// https://atomiks.github.io/tippyjs
@Directive({
  selector: '[appTooltip]',
  standalone: false
})
export class TooltipDirective implements OnInit, OnDestroy, OnChanges {
  @Input('appTooltip') message: string;
  @Input('appTooltipDisabled') disabled: boolean = false;
  @Input('appTooltipPlacement') placement: IFBTooltipPlacement = 'top';
  @Input('appTooltipVariant') variant: IFBTooltipVariant = 'regular';

  @Output() created = new EventEmitter<Instance>();

  private instance: Instance = null;

  constructor(private elementRef: ElementRef) {}

  ngOnDestroy(): void {
    this.instance.destroy();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.message?.isFirstChange()) {
      this.message = changes.message?.currentValue;
      this.instance.setContent(this.message);
    }

    if (changes.disabled) {
      if (changes.disabled?.currentValue) {
        this.instance.enable();
      } else {
        this.instance.disable();
      }
    }
  }

  ngOnInit(): void {
    this.instance = tippy(
      this.elementRef.nativeElement as Element,
      {
        ...TOOLTIP_DEFAULT_OPTIONS,
        content: this.message,
        maxWidth: ['wide', 'wide-hint'].includes(this.variant) ? 300 : 200,
        placement: this.placement,
        theme: VariantThemeMap[this.variant],
        popperOptions: {
          strategy: 'fixed',
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                padding: browserHelper.isMobile ? 15 : 50
              }
            }
          ]
        }
      } as any
    ) as Instance;

    this.created.emit(this.instance);
  }
}
